<template>
  <div class="content">
    <!-- 开户按钮 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin-right:20px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
        >导出 Excel（数量/ {{ vipCardList.length }}条）</el-button>
      </el-form-item>
      <!-- <el-form-item label="提现状态: ">
        <el-select v-model="cardType" placeholder="请选择" clearable>
          <template v-for="item in cardTypeArr">
            <el-option :label="item.name" :value="item.name" :key="item.id"></el-option>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="selectBtn">查询</el-button>
      </el-form-item> -->
    </el-form>
    <!-- 商品表格 -->
    <div style="height:80%">
      <el-table
        :data="vipCardList"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        :header-cell-style="{background:'#e8effc', color:'#000'}"
      >
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column label="用户id" width="100" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.userId }}</span>
          </template>
        </el-table-column>
          <el-table-column label="用户手机号" width="130" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.phone }}</span>
          </template>
        </el-table-column>
          <el-table-column label="用户收款账户" width="220" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.payAccount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="兑换积分" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.money}}</span>
          </template>
        </el-table-column>
        <el-table-column label="提现状态" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.cashStatus}}</span>
          </template>
        </el-table-column>
        <el-table-column label="发起时间" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.createTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="shenheBtn(scope.row)">审核</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 开户表单 -->
    <el-dialog title="审核" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="提现状态: ">
          <el-select v-model="eitecardType" placeholder="请选择" clearable>
            <div v-for="item in cardTypeArr" :key="item.id">
              <el-option :label="item.name" :value="item.name" ></el-option>
            </div>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updatestatus, selectmoneyrecord } from "@/services/vipCard";
export default {
  data() {
    return {
      downloadLoading: false,
      vipCardList: [],
      cardTypeArr: [
        { id: 1, name: "审核中" },
        { id: 2, name: "已通过" },
        { id: 3, name: "驳回" }
      ],
      cardType: "",
      eitecardType: "",
      supplierPhone: "",
      phone: "",
      cardNumber: "",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: 1 },
        { name: "普通子账号权限", id: 2 }
      ],
      form: {},
      dialogFormVisible: false
    };
  },
  created() {
    // 查询数据
    this.select();
  },
  methods: {
    selectBtn() {
      this.select();
    },
    // 查询
    select() {
      selectmoneyrecord().then(resp => {
        console.log(resp, "----------------------------");
        this.loading = false;
        this.vipCardList = resp.data;
      });
    },
    // 审核按钮弹窗按钮
    shenheBtn(row) {
      this.dialogFormVisible = true;
      this.form = row;
      this.eitecardType = row.cashStatus;
      console.log(row);
    },
    // 表单提交按钮
    sumbmitBtn() {
      if (this.eitecardType == "") {
        this.$message({
          type: "info",
          message: "请选择类型"
        });
        return;
      }
      console.log(this.form.id, this.eitecardType);
      updatestatus(this.form.id, this.eitecardType).then(resp => {
        console.log(resp);
        if (resp.data.code == 200) {
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: `修改成功!`
          });
          this.select();
        } else {
          this.$message({
            type: "info",
            message: "系统错误"
          });
        }
      });
    },
    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(row.id, this.eitecardType);
          // deleterole(row.id).then(resp => {
          //   console.log(resp);
          //   this.$message({
          //     type: "success",
          //     message: "删除成功!"
          //   });
          this.select();
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../vendor/Export2Excel").then(excel => {
        const tHeader = ["用户手机号", "用户支付宝", "提现金额","提现状态","提现发起时间"];
        const filterVal = ["phone", "payAccount", "money", "cashStatus", "createTime"];
        const list = this.vipCardList;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "提现审核列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    }
  }
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>